import { render, staticRenderFns } from "./enterSecretQuestionPage.vue?vue&type=template&id=09d218b2&scoped=true&"
import script from "./enterSecretQuestionPage.vue?vue&type=script&lang=js&"
export * from "./enterSecretQuestionPage.vue?vue&type=script&lang=js&"
import style0 from "./enterSecretQuestionPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./enterSecretQuestionPage.vue?vue&type=style&index=1&id=09d218b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d218b2",
  null
  
)

export default component.exports